import React from 'react';
import URLSanitizer from '../services/url-sanitizer';

const StoreTile = ({ name, styles, logo }) => (
    <img
        className={styles}
        alt={name}
        src={URLSanitizer.makeAbsolute(logo)}
    />
);

export default StoreTile;



/** WEBPACK FOOTER **
 ** ./src/components/store-tile.jsx
 **/